import React from 'react';
import AppVariables from "../../common/AppVariables";

const Footer = () => {
  return  <footer className="app-footer clearfix">
    <div className="pull-right">
      <a href={AppVariables.AppCompanyWebsite}><b>{AppVariables.AppCompanyName}</b></a> &copy; {AppVariables.ApplicationYear}
    </div>
  </footer>
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js